import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getBlogArticle } from '../../api';
import { FiArrowLeft, FiClock, FiEye, FiCalendar, FiTag } from 'react-icons/fi';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogArticle(slug)
      .then(({ data }) => setArticle(data))
      .catch(() => navigate('/blog'))
      .finally(() => setLoading(false));
  }, [slug, navigate]);

  if (loading) return (
    <div className="blogpost-page container">
      <div style={{ paddingTop: 100 }}>
        <div className="skeleton" style={{ height: 40, width: '60%', marginBottom: 16 }} />
        <div className="skeleton" style={{ height: 400, marginBottom: 24 }} />
        <div className="skeleton" style={{ height: 200 }} />
      </div>
    </div>
  );

  if (!article) return null;

  const coverImg = article.images?.find((i) => i.order === 0) || article.images?.[0];

  return (
    <div className="blogpost-page">
      {/* Cover Image */}
      {coverImg && (
        <div className="blogpost-cover">
          <img src={coverImg.image} alt={coverImg.alt || article.title} />
          <div className="blogpost-cover-overlay" />
        </div>
      )}

      <div className="container">
        <div className="blogpost-inner">
          {/* Back */}
          <button className="btn btn-ghost back-btn" onClick={() => navigate('/blog')}>
            <FiArrowLeft /> Back to Blog
          </button>

          {/* Header */}
          <div className="blogpost-header">
            {article.category && (
              <Link to={`/blog?category=${article.category?.slug || article.category}`} className="blogpost-cat">
                {article.category?.name || article.category}
              </Link>
            )}
            <h1 className="blogpost-title">{article.title}</h1>
            {article.meta_description && <p className="blogpost-excerpt">{article.meta_description}</p>}

            <div className="blogpost-meta">
              <span><FiCalendar /> {new Date(article.created_at).toLocaleDateString('en-NP', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
              {article.read_time && <span><FiClock /> {article.read_time} min read</span>}
              {article.views !== undefined && <span><FiEye /> {article.views} views</span>}
            </div>

            {/* Tags */}
            {article.tags?.length > 0 && (
              <div className="blogpost-tags">
                <FiTag />
                {article.tags.map((t) => (
                  <Link key={t.id || t} to={`/blog?tag=${t.slug || t}`} className="blogpost-tag">
                    #{t.name || t}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Content */}
          <div
            className="blogpost-content"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          {/* Article Images Gallery */}
          {article.images?.length > 1 && (
            <div className="blogpost-gallery">
              <h3>Gallery</h3>
              <div className="gallery-grid">
                {article.images.slice(1).map((img) => (
                  <div key={img.id} className="gallery-img">
                    <img src={img.image} alt={img.alt || ''} loading="lazy" />
                    {img.caption && <p className="gallery-caption">{img.caption}</p>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Footer */}
          <div className="blogpost-footer">
            <Link to="/blog" className="btn btn-outline">← More Articles</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
